import styled from 'styled-components';
import TableContainer from '@mui/material/TableContainer';
import TableCell from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';

export const Container = styled.div`
    display: flex;
    flex-direction: column;
    gap: 24px;
    width: 100%;
    align-items: center;

    & > *:first-child {
        margin-top: 12px;
        padding-top: 8px;
    }

    @media (min-width: 576px) {
        gap: 28px;

        & > *:first-child {
            margin-top: 16px;
            padding-top: 12px;
        }
    }

    @media (min-width: 768px) {
        gap: 32px;

        & > *:first-child {
            margin-top: 20px;
            padding-top: 16px;
        }
    }

    .MuiOutlinedInput-root fieldset {
        border-width: 1px !important;
        border-color: rgba(242, 146, 5, 0.32) !important;
    }

    .MuiOutlinedInput-root:hover fieldset {
        border-color: rgba(242, 146, 5, 0.5) !important;
    }

    .MuiOutlinedInput-root.Mui-focused fieldset {
        border-color: #00d4ff !important;
    }
`;

export const CalcFormCenter = styled.div`
    width: 100%;
    max-width: 680px;
    margin: 0 auto;
    display: flex;
    flex-direction: column;
    align-items: center;

    & > * {
        width: 100%;
    }
`;

export const CalcSection = styled.section`
    display: flex;
    flex-direction: column;
    gap: 14px;
    width: 100%;
    align-items: center;
`;

export const CalcFieldRow = styled.div`
    display: flex;
    flex-wrap: wrap;
    align-items: flex-end;
    justify-content: center;
    gap: 12px 14px;
    width: 100%;

    @media (max-width: 767px) {
        flex-direction: column;
        align-items: stretch;
        justify-content: flex-start;
        gap: 14px;
    }
`;

export const CalcInputWrap = styled.div`
    flex: 1 1 200px;
    min-width: 140px;
    max-width: 280px;

    @media (max-width: 767px) {
        flex: 1 1 auto;
        width: 100%;
        max-width: none;
        min-width: 0;
    }

    .MuiFormControl-root {
        width: 100%;
    }
`;

export const CalcButtonWrap = styled.div`
    flex: 0 0 auto;
    display: flex;
    align-items: stretch;
    align-self: flex-end;

    @media (max-width: 767px) {
        width: 100%;
        align-self: stretch;

        .MuiButton-root {
            width: 100% !important;
            min-height: 44px !important;
            height: 44px !important;
            padding: 10px 18px !important;
        }
    }

    .MuiButton-root {
        min-height: 48px !important;
        height: 48px !important;
        padding: 0 22px !important;
        box-sizing: border-box !important;
        display: inline-flex !important;
        align-items: center !important;
        justify-content: center !important;
    }

    @media (min-width: 768px) {
        .MuiButton-root {
            min-height: 52px !important;
            height: 52px !important;
        }
    }

    @media (min-width: 992px) {
        .MuiButton-root {
            min-height: 56px !important;
            height: 56px !important;
        }
    }
`;

export const CalcTableOuter = styled.div`
    width: 100%;
    max-width: 680px;
    margin: 0 auto;
    border-radius: 14px;
    overflow: hidden;
    min-width: 0;
    border: 1px solid rgba(242, 146, 5, 0.28);
    background: linear-gradient(
        165deg,
        rgba(12, 18, 32, 0.75) 0%,
        rgba(0, 0, 0, 0.45) 100%
    );
    box-shadow:
        0 8px 32px rgba(0, 0, 0, 0.35),
        inset 0 1px 0 rgba(255, 255, 255, 0.05);
`;

export const StyledTableContainer = styled(TableContainer).attrs({
    component: 'div',
})`
    background: transparent !important;
    box-shadow: none !important;
    width: 100%;
    max-width: 100%;
    overflow-x: auto !important;
    -webkit-overflow-scrolling: touch !important;

    .MuiTable-root {
        min-width: 520px;
    }

    @media (min-width: 768px) {
        overflow-x: visible !important;

        .MuiTable-root {
            min-width: 0;
            width: 100%;
        }
    }
`;

export const TableHeadRow = styled(TableRow)`
    && {
        background: rgba(242, 146, 5, 0.1);
    }
`;

export const TableHeadCell = styled(TableCell)`
    && {
        position: sticky;
        top: 0;
        z-index: 2;
        background: rgba(18, 26, 42, 0.98) !important;
        backdrop-filter: blur(8px);
        color: rgba(200, 210, 235, 0.95) !important;
        font-size: 11px !important;
        font-weight: 700 !important;
        letter-spacing: 0.08em;
        text-transform: uppercase;
        border-bottom: 1px solid rgba(242, 146, 5, 0.35) !important;
        padding: 10px 8px !important;
        line-height: 1.25 !important;

        @media (min-width: 768px) {
            font-size: 12px !important;
            letter-spacing: 0.1em;
            padding: 12px 10px !important;
        }
    }
`;

export const TableBodyRow = styled(TableRow)`
    && {
        transition: background 0.15s ease;
    }

    &:nth-of-type(even) {
        background: rgba(0, 0, 0, 0.18);
    }

    &:hover {
        background: rgba(242, 146, 5, 0.07) !important;
    }

    &:last-of-type td {
        border-bottom: none;
    }
`;

export const TableBodyCell = styled(TableCell)`
    && {
        color: rgba(230, 235, 250, 0.94) !important;
        font-size: 13px !important;
        border-bottom: 1px solid rgba(255, 255, 255, 0.06) !important;
        padding: 8px 8px !important;
        font-variant-numeric: tabular-nums;

        @media (min-width: 768px) {
            font-size: 14px !important;
            padding: 10px 10px !important;
        }
    }

    &&.calc-cell-num {
        font-weight: 600;
        color: #ffc078 !important;
    }
`;

export const calcPrimaryButtonStyle = {
    background: 'linear-gradient(135deg, #f29205 0%, #ff6b35 100%)',
    border: 'none',
    color: '#ffffff',
    padding: '0 22px',
    borderRadius: '10px',
    fontWeight: 600,
    fontSize: 14,
    boxShadow: '0 4px 15px rgba(242, 146, 5, 0.35)',
    minWidth: 120,
    textTransform: 'none',
    transition: 'all 0.25s ease',
};
